import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/index",
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/index.vue"),
    props: true,
  },
  {
    path: "/list/id=:id",
    name: "list",
    component: () => import("../views/list.vue"),
  },
  {
    path: "/content/zid=:zid&id=:id",
    name: "content",
    component: () => import("../views/content.vue"),
  },
  {
    path: "/close",
    name: "close",
    component: () => import("../views/close.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


// router.beforeEach((to,from,next) => {
//   const open = localStorage.getItem("open_pages") || 0; 
//   if ((to.name === 'index' || to.name === 'list' || to.name === 'content') && open == 1) {  
//     next({ path: "/close" });   
//   } else {  
//     next();   
//   }  
// })



export default router;
